import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { Ref } from 'vue'
import type { Participant, ParticipantSearchResult } from '../../types/index.ts'

import { t } from '@nextcloud/l10n'
import { computed, inject, ref } from 'vue'
import NcChip from '@nextcloud/vue/components/NcChip'
import AvatarWrapper from '../AvatarWrapper/AvatarWrapper.vue'
import { AVATAR } from '../../constants.ts'


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactSelectionBubble',
  props: {
    participant: {}
  },
  emits: ['update'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

// Defines list of locked participants (can not be removed manually
const lockedParticipants = inject<Ref<(Participant | ParticipantSearchResult)[]>>('lockedParticipants', ref([]))

const isLocked = computed(() => lockedParticipants.value.some((item) => {
	if ('actorId' in props.participant) {
		return ('actorId' in item)
			? item.actorId === props.participant.actorId && item.actorType === props.participant.actorType
			: item.id === props.participant.actorId && item.source === props.participant.actorType
	} else {
		return ('actorId' in item)
			? item.actorId === props.participant.id && item.actorType === props.participant.source
			: item.id === props.participant.id && item.source === props.participant.source
	}
}))

const actorId = computed(() => {
	return ('actorId' in props.participant) ? props.participant.actorId : props.participant.id
})
const actorType = computed(() => {
	return ('actorId' in props.participant) ? props.participant.actorType : props.participant.source
})
const computedName = computed(() => {
	return (('actorId' in props.participant) ? props.participant.displayName : props.participant.label) || t('spreed', 'Guest')
})
const token = computed(() => {
	return ('actorId' in props.participant) ? props.participant.roomToken : 'new'
})
const removeLabel = computed(() => t('spreed', 'Remove participant {name}', { name: computedName.value }))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NcChip), {
    text: computedName.value,
    "aria-label-close": removeLabel.value,
    "no-close": isLocked.value,
    onClose: _cache[0] || (_cache[0] = ($event: any) => (emit('update', __props.participant)))
  }, {
    icon: _withCtx(() => [
      _createVNode(AvatarWrapper, {
        id: actorId.value,
        token: token.value,
        name: computedName.value,
        source: actorType.value,
        size: _unref(AVATAR).SIZE.EXTRA_SMALL,
        "disable-menu": "",
        "disable-tooltip": ""
      }, null, 8, ["id", "token", "name", "source", "size"])
    ]),
    _: 1
  }, 8, ["text", "aria-label-close", "no-close"]))
}
}

})